/* ********************************************
 * import
 * ****************************************** */
import 'intersection-observer';
import {scrollToSmooth} from "../modules/scrollToSmooth";
import {eventObserver} from "../barba/eventObserver";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";


/* ********************************************
 * functions
 * ****************************************** */
export function scrollToTop() {
  const listeners = [];
  const btns = document.querySelectorAll('[data-scroll-top]');

  const toTop = () => {
    scrollToSmooth('windowTop');
  };

  if (btns) {
    btns.forEach(btn => {
      btn.addEventListener('click', toTop);
      listeners.push([btn, 'click', toTop]);
    });
  }

  eventObserver.observeEvents(listeners);
}



// =============================================================
// scrollContentsObserver
// viewportに入ったコンテンツに特定のクラスを付与する関数
// =============================================================

export function scrollContentsObserver() {

  const observeContents = document.querySelectorAll('.js-txt-up, .js-txt-view, .js-scroll-observe');
  observeContents.forEach((tgt) => {
    gsap.to(tgt, {
      scrollTrigger: {
        trigger: tgt,
        start: "top bottom",
        onEnter: () => {
          // is-activeクラスを追加するアニメーション
          // 必要に応じてアニメーションの詳細（例：遅延時間）を調整できます
          gsap.to(tgt, {
            onStart: () => tgt.classList.add('is-active'),
            // delay: index * 0.1, // 要素ごとに少し遅延させる
          });
        },
        toggleActions: "play none none none",
      },
    });
  });

}

/*
export function scrollContentsObserver() {

  const target = document.querySelectorAll('.js-txt-up, .js-txt-view, .js-scroll-observe');
  const targetArray = Array.prototype.slice.call(target);

  // オプション設定
  const options = {
    root: null,
    rootMargin: '0px 0px',
    threshold: 0,
  };

  const observer = new IntersectionObserver(callback, options);
  targetArray.forEach((tgt) => {
    observer.observe(tgt);
  });

  let index = 0;
  function callback(entries) {
    entries.forEach(function(entry) {
      const target = entry.target;
      if (entry.isIntersecting && !target.classList.contains('is-active')) {
        const delay = index * 100;
        setTimeout(function() {
          target.classList.add('is-active');
        }, delay);
        index++;
      }
    });
  }
}
*/


// =============================================================
// scrollUpDownObserver
// 上下スクロールの検知
// =============================================================
export function scrollUpDownObserver() {
  const body = document.body;

  // スクロール方法を検知
  ScrollTrigger.create({
    start: 'top top',
    end: 'bottom bottom',
    onUpdate: (self) => {
      if (self.direction === 1) { // 下にスクロールしている場合
        body.classList.remove('is-scroll-up');
        body.classList.add('is-scroll-down');
      } else if (self.direction === -1) { // 上にスクロールしている場合
        body.classList.remove('is-scroll-down');
        body.classList.add('is-scroll-up');
      }
    },
  });
}


// =============================================================
// imageParallaxScrollEffect
// 画像の視差スクロール
// =============================================================
export function imageParallaxScrollEffect() {
  // Parallax effect 1
  const pax1 = gsap.utils.toArray(".js-pax-outer");
  if (pax1.length > 0) {
    pax1.forEach(elm => {
      if (window.getComputedStyle(elm).getPropertyValue('display') === 'inline') {
        elm.style.display = 'inline-block';
      }
      const elmOuterHeight = elm.clientHeight;
      const elmInner = elm.querySelector(".js-pax-inner");
      const elmInnerHeight = elmInner.clientHeight;
      const elmDiffHeight = elmInnerHeight - elmOuterHeight;

      gsap.from(elmInner, {
        y: -elmDiffHeight,
        scrollTrigger: {
          trigger: elm,
          start: 'top bottom', // top-=100 bottom
          end: 'bottom top',
          scrub: 1,
          invalidateOnRefresh: true, // update on resize
        },
      });
    });
  }
}



// TODO 以下
// scrollに応じて、bodyや特定の要素にに特定のクラスを付与
// ページ遷移の度に特定のクラスの除去を管理

/*
// =============================================================
// floatingHeader
// フローティングヘッダーのクラスを変更
// =============================================================
export function floatingHeader() {

  // intersection-observerAPIだと、
  // ページ遷移時に要素の重なりを検知してしまい、
  // 誤作動が起きるため、以下の書き方。
  const header = document.querySelector('#header');
  const hum = document.querySelector('#hum');
  const main = document.querySelector('.main');
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        header.classList.remove('scrolled');
        hum.classList.remove('scrolled');
      } else {
        header.classList.add('scrolled');
        hum.classList.add('scrolled');
      }
    });
  }, observerOptions);

  observer.observe(main);
}
*/
